/* global axios */
import ApiClient from './ApiClient';

class VoiceSipSessionAPI extends ApiClient {
  constructor() {
    super('voice_sip_session', { accountScoped: true });
  }

  claim(data) {
    return axios.post(this.url, data);
  }

  heartbeat(data) {
    return axios.patch(this.url, data);
  }

  release(data) {
    return axios.delete(this.url, { data });
  }

  getConfig() {
    return axios.get(`${this.url}/sip_config`);
  }

  saveConfig(data) {
    return axios.patch(`${this.url}/sip_config`, data);
  }

  deleteConfig() {
    return axios.delete(`${this.url}/sip_config`);
  }

  logCall(data) {
    return axios.post(`${this.url}/call_log`, data);
  }
}

export default new VoiceSipSessionAPI();
